import "video-react/styles/scss/video-react.scss";
import React, { PureComponent } from 'react';
import { Player, BigPlayButton } from 'video-react';
import styled from 'styled-components';

import HLSSource from './HLSSource';
import { __ } from '~/i18n'

const VideoOverlay = styled.div`
  position: relative;
  font-size: 9px;
`;

const PlayButtonText = styled.span`
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
`;

const PlayButton = styled.button`
  background: none;
  color: inherit;
  cursor: pointer;
  overflow: visible;
  text-transform: none;
  text-decoration: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;

  font-family: 'video-react' !important;
  speak: none;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  font-size: 3em;
  line-height: 1.5em;
  height: 1.5em;
  width: 3em;
  display: block;
  position: absolute;
  padding: 0;
  opacity: 1;
  border: 0.06666em solid #fff;
  background-color: #2B333F;
  background-color: rgba(43, 51, 63, 0.7);
  border-radius: 0.3em;
  -webkit-transition: all 0.4s;
  transition: all 0.4s;

  top: 50%;
  left: 50%;
  margin-top: -0.75em;
  margin-left: -1.5em;
  z-index: 2;

  &:before {
    color: white;
    text-align: center;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    content: "\\F200";
  }

  &:focus {
    outline: 0;
    border-color: #fff;
    background-color: #73859f;
    background-color: rgba(115, 133, 159, 0.5);
    -webkit-transition: all 0s;
    transition: all 0s;
  }
`;

export default class Video extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      initialized: false,
      loaded: false,
    }
  }

  componentDidMount() {
    // subscribe state change

  }

  handleStateChange = (state, prevState) => {
    const { onStateChange } = this.props;

    if(onStateChange) {
      onStateChange(state, prevState);
    }
  };

  componentDidUpdate(prevProps, prevState) {
    if (this.state.initialized && !prevState.initialized) {
      this._player.load();
    }

    if(prevProps.hlsSource !== this.props.hlsSource) {
      this._player.pause();
      this._player.load();
      // this.setState({loaded: false});
    }
  }

  handleInit = (e) => {
    e.preventDefault();
    const { initialized } = this.state;
    if(!initialized && this._player) {
      // this._source.startLoad();
      // this._player.play();
      this.setState({initialized: true});
    }else {
      // console.log('play');
      // this._player.play();
    }
  };

  handleManifestParsed = () => {
    const { onManifestParsed } = this.props;
    const { loaded } = this.state;

    if(onManifestParsed) {
      onManifestParsed();
    }

    if(this._player && !loaded) {
      this._player.play();
      this.setState({loaded: true});
    }

  };

  render() {
    const { hlsSource, ...restProps } = this.props;
    const { initialized } = this.state;

    let content = (
      <Player
        {...restProps}
        playsInline
        preload="metadata"
        autoPlay={ false }
        ref={ (c) => {this._player = c; this._player && this._player.subscribeToStateChange(this.handleStateChange); } }
      >
        { hlsSource && initialized ?
          <HLSSource
            key={hlsSource}
            isVideoChild
            src={ hlsSource }
            onManifestParsed={ this.handleManifestParsed }
          />
          : null }
        <BigPlayButton position="center" />

      </Player>
    );

    if(!initialized) {
      return (
        <VideoOverlay onClick={ this.handleInit }>
          <PlayButton
            type="button"
            aria-live="polite"
            tabIndex="0"
          >
            <PlayButtonText>{ __('Play Video') }</PlayButtonText>
          </PlayButton>
          { content }
        </VideoOverlay>
      );
    }

    return content;
  }
}
